var _rect, _rect2, _rect3, _g, _g2, _g3, _ellipse, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeaderBgImage = function SvgHeaderBgImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1860,
    height: 224,
    viewBox: "0 0 1860 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1750_61426)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1860,
    height: 224,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1750_61426)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -339,
    width: 1885,
    height: 2534,
    rx: 200.249,
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1750_61426)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3003.73,
    height: 2503.11,
    transform: "translate(-25 2664.73) rotate(-90)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1750_61426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1532.53 -1241.45C1170.66 -1579.15 543.196 -1085.82 206.149 -724.65C-130.898 -363.48 -1197.95 -949.35 -914.431 -250.529C-782.851 73.7894 -576.281 212.742 -259.208 360.931C493.993 712.953 1240.43 385.137 1577.48 23.9671C1914.52 -337.203 1894.4 -903.749 1532.53 -1241.45Z",
    fill: "#90CAFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1750_61426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.792 304.332C-245.804 31.0933 -944.657 -182.741 -1531.7 -145.489C-3401.05 -26.8641 -1908.16 3089.66 -309.394 3690.72C1051.18 4202.24 3800.2 4643.42 3998.13 3413.46C4123.66 2633.48 3852.36 1807.91 2963.55 1520.72C2436.02 1350.27 1541.08 1474.57 1080.89 1221.61C720.903 1023.73 517.571 522.346 178.792 304.332Z",
    fill: "#DAFFEF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1750_61426)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2596.1,
    cy: 935.817,
    r: 1704.02,
    transform: "rotate(-90 2596.1 935.817)",
    fill: "#F47BFF",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    },
    filter: "url(#filter3_f_1750_61426)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.156,
    cy: 3239.63,
    rx: 1258.51,
    ry: 956.887,
    transform: "rotate(-90 306.156 3239.63)",
    fill: "#FFE600"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1015.79 -392.576C1123.46 -441.858 1251.55 -521.508 1356.04 -465.8C1464.26 -408.105 1439.22 -241.967 1499.07 -134.924C1545.78 -51.3794 1659.08 -4.70996 1667.17 90.6631C1675.26 185.985 1560.12 247.763 1539.46 341.17C1507.94 483.72 1639.41 690.132 1517 769.693C1397.45 847.392 1271.97 627.52 1130.92 606.702C1013.41 589.357 876.075 739.445 786.155 661.824C692.286 580.794 805.995 417.077 772.834 297.588C745.677 199.731 613.055 145.902 614.795 44.3611C616.533 -57.0316 712.842 -128.07 781.409 -202.783C850.788 -278.38 922.49 -349.872 1015.79 -392.576Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95875,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.58 -375.35C1127.91 -420.845 1258.7 -495.976 1361.19 -436.656C1467.33 -375.218 1436.5 -210.056 1492.58 -100.989C1536.34 -15.8655 1647.94 34.7296 1652.7 130.327C1657.46 225.873 1540.24 283.595 1516.33 376.224C1479.85 517.587 1604.03 728.462 1478.92 803.703C1356.74 877.182 1239.01 653.065 1098.77 627.336C981.935 605.901 839.447 751.105 752.29 670.392C661.307 586.136 780.66 426.487 751.69 305.914C727.964 207.169 597.302 148.744 602.585 47.3258C607.86 -53.9445 706.59 -121.578 777.723 -193.853C849.697 -266.983 923.85 -335.928 1018.58 -375.35Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9175,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.78 -358.038C1131.62 -399.689 1264.96 -470.21 1365.31 -407.349C1469.24 -342.245 1432.67 -178.259 1484.9 -67.3015C1525.67 19.2975 1635.44 73.7566 1636.86 169.462C1638.28 265.116 1519.11 318.712 1491.99 410.45C1450.6 550.454 1567.35 765.534 1439.69 836.362C1315.01 905.533 1205.18 677.444 1065.93 646.837C949.906 621.337 802.437 761.48 718.15 677.774C630.163 590.394 755.015 435.008 730.27 313.497C710.005 213.984 581.461 151.035 590.28 49.8627C599.086 -51.1618 700.117 -115.309 773.728 -185.057C848.211 -255.63 924.725 -321.946 1020.78 -358.038Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87625,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.36 -340.659C1134.6 -378.417 1270.31 -444.241 1368.41 -377.917C1470 -309.225 1427.73 -146.616 1476.06 -33.9023C1513.79 54.0668 1621.58 112.324 1619.66 208.02C1617.74 303.665 1496.78 353.07 1466.47 443.806C1420.22 582.279 1529.39 801.303 1399.34 867.633C1272.32 932.411 1170.52 700.627 1032.42 665.179C917.357 635.645 765.087 770.556 683.773 683.961C598.889 593.563 729.088 442.628 708.599 320.328C691.819 220.168 565.55 152.771 577.895 51.9687C590.221 -48.687 693.429 -109.269 769.43 -176.406C846.33 -244.336 925.112 -307.942 1022.36 -340.659Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1023.34 -323.236C1136.83 -357.054 1274.76 -418.101 1370.48 -348.394C1469.62 -276.198 1421.69 -115.163 1466.06 -0.831946C1500.69 88.4 1606.39 150.383 1601.13 245.955C1595.87 341.474 1473.26 386.627 1439.8 476.25C1388.75 613.025 1490.21 835.726 1357.92 897.477C1228.72 957.782 1135.07 722.586 998.287 682.34C884.329 648.809 727.443 778.324 649.201 688.943C567.523 595.638 702.91 449.339 686.702 326.399C673.428 225.714 549.588 153.952 565.443 53.6411C581.275 -46.5231 686.534 -103.466 764.832 -167.91C844.056 -233.115 925.01 -293.932 1023.34 -323.236Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79375,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1023.72 -305.789C1138.31 -335.626 1278.29 -391.823 1371.52 -318.817C1468.07 -243.205 1414.56 -83.9411 1454.91 31.8692C1486.41 122.255 1589.88 187.89 1581.29 283.219C1572.7 378.497 1448.59 419.344 1412.02 507.745C1356.22 642.654 1449.85 868.76 1315.48 925.856C1184.26 981.616 1098.87 743.295 963.58 698.3C850.861 660.812 689.551 784.773 614.476 692.716C536.104 596.617 676.515 455.133 664.607 331.701C654.855 230.615 533.595 154.574 552.941 54.8779C572.259 -44.6727 679.441 -97.9077 759.94 -159.579C841.392 -221.98 924.419 -279.935 1023.72 -305.789Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7525,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1023.48 -288.34C1139.04 -314.159 1280.9 -365.437 1371.52 -289.221C1465.38 -210.286 1406.34 -52.9867 1442.63 64.1613C1470.95 155.591 1572.07 224.797 1560.15 319.769C1548.25 414.689 1422.78 451.179 1383.16 538.25C1322.68 671.13 1408.36 900.366 1272.08 952.738C1139 1003.88 1061.97 762.728 928.337 713.039C816.995 671.64 651.457 789.896 579.64 695.275C504.67 596.499 649.933 460.001 642.34 336.23C636.122 234.864 517.59 154.638 540.403 55.6777C563.184 -43.1381 672.158 -92.6001 754.761 -151.425C838.34 -210.945 923.34 -265.967 1023.48 -288.34Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.63 -270.91C1139.03 -292.68 1282.58 -338.975 1370.49 -259.644C1461.54 -177.481 1397.05 -22.338 1429.22 96.005C1454.34 188.368 1552.98 261.06 1537.76 355.558C1522.54 450.005 1395.88 482.094 1353.24 567.729C1288.17 698.418 1365.79 930.504 1227.77 978.088C1092.98 1024.56 1024.42 780.862 892.601 726.539C782.772 681.28 613.208 793.686 544.737 696.616C473.26 595.284 623.197 463.939 619.929 339.978C617.252 238.457 501.592 154.143 527.845 56.0394C554.06 -41.9212 664.695 -87.5499 749.3 -143.456C834.906 -200.023 921.774 -252.045 1022.63 -270.91Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021.18 -253.519C1138.26 -271.214 1283.35 -312.472 1368.43 -230.12C1456.56 -144.83 1386.69 7.96769 1414.72 127.361C1436.59 220.544 1532.64 296.635 1514.13 390.544C1495.63 484.403 1367.92 512.052 1322.32 596.147C1252.72 724.485 1322.2 959.139 1182.6 1001.88C1046.27 1043.61 986.262 797.674 856.416 738.784C748.233 689.719 574.849 796.139 509.808 696.739C441.91 592.974 596.341 466.942 597.4 342.942C598.268 241.39 485.621 153.09 515.282 55.9626C544.9 -41.0234 657.06 -82.7632 743.564 -135.682C831.092 -189.228 919.723 -238.186 1021.18 -253.519Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62875,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1019.12 -236.19C1136.75 -249.789 1283.18 -285.957 1365.35 -200.687C1450.44 -112.373 1375.28 37.8935 1399.12 158.193C1417.73 252.082 1511.06 331.479 1489.29 424.685C1467.52 517.84 1338.93 541.016 1290.42 623.468C1216.39 749.298 1277.64 986.234 1136.63 1024.07C998.929 1061.03 947.537 813.144 819.825 749.758C713.421 696.947 536.428 797.252 474.896 695.642C410.661 589.571 569.396 469.005 574.782 345.118C579.193 243.658 469.697 151.481 502.73 55.4474C535.714 -40.4458 649.262 -78.2459 737.561 -128.114C826.904 -178.572 917.189 -224.407 1019.12 -236.19Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5875,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.45 -218.944C1134.49 -228.429 1282.1 -259.465 1361.23 -171.379C1443.19 -80.1492 1362.84 67.4029 1382.47 188.461C1397.79 282.943 1488.29 365.548 1463.27 457.937C1438.27 550.277 1308.95 568.95 1257.59 649.659C1179.21 772.829 1232.16 1011.76 1089.92 1044.65C951.005 1076.78 908.296 827.253 782.874 759.448C678.377 702.957 497.992 797.023 440.043 693.328C379.549 585.08 542.395 470.127 552.102 346.503C560.051 245.259 453.838 149.317 490.203 54.4945C526.514 -40.1892 641.312 -74.0035 731.297 -120.76C822.347 -168.069 914.176 -210.726 1016.45 -218.944Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54625,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1013.19 -201.801C1131.48 -207.161 1280.09 -233.026 1356.1 -142.232C1434.83 -48.1978 1349.37 96.46 1364.76 218.129C1376.77 313.088 1464.34 398.802 1436.12 490.261C1407.91 581.672 1278.01 595.821 1223.87 674.688C1141.24 795.048 1185.81 1035.68 1042.51 1063.59C902.561 1090.85 868.586 839.984 745.607 767.844C643.146 707.739 459.588 795.453 405.292 689.798C348.613 579.505 515.372 470.306 529.387 347.096C540.865 246.191 438.065 146.6 477.716 53.1049C517.31 -40.2538 633.218 -70.0412 724.78 -113.628C817.426 -157.731 910.688 -197.157 1013.19 -201.801Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1009.33 -184.783C1127.74 -186.011 1277.15 -206.674 1349.95 -113.283C1425.35 -16.558 1334.89 125.029 1346.03 247.162C1354.72 342.482 1439.24 431.199 1407.84 521.618C1376.46 611.989 1246.15 621.596 1189.29 698.525C1102.51 815.928 1138.66 1057.97 994.468 1080.86C853.656 1103.22 828.456 851.321 708.07 774.933C607.768 711.29 421.261 792.543 370.686 685.059C317.891 572.854 488.359 469.541 506.665 346.895C521.658 246.452 422.396 143.335 465.286 51.2804C508.114 -40.6397 624.991 -66.3637 718.018 -106.729C812.147 -147.571 906.728 -183.719 1009.33 -184.783Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46375,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.88 -167.909C1123.26 -165.004 1273.3 -180.441 1342.8 -84.565C1414.77 14.7319 1319.43 153.076 1326.3 275.523C1331.66 371.088 1413.03 462.701 1378.5 551.969C1343.98 641.19 1213.42 646.243 1153.9 721.141C1063.08 835.444 1090.75 1078.6 945.855 1096.45C804.348 1113.88 787.955 861.251 670.308 780.708C572.289 713.603 383.059 788.298 336.266 679.114C287.419 565.136 461.389 467.834 483.965 345.902C502.453 246.044 406.851 139.525 452.928 49.0233C498.937 -41.3461 616.64 -62.9756 711.02 -100.07C806.516 -137.602 902.302 -170.426 1004.88 -167.909Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4225,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999.84 -151.201C1118.04 -144.167 1268.54 -154.357 1334.64 -56.1148C1403.11 45.6336 1303 180.566 1305.59 303.178C1307.61 398.872 1385.74 493.269 1348.11 581.278C1310.5 669.239 1179.84 669.733 1117.75 742.508C1022.99 853.572 1042.16 1097.54 896.728 1110.32C754.699 1122.81 747.132 869.761 632.367 785.162C536.75 714.677 345.029 782.722 302.075 671.971C257.235 556.358 434.495 465.187 461.312 344.118C483.275 244.965 391.448 135.175 440.655 46.3362C489.79 -42.3725 608.177 -59.8809 703.794 -93.6585C800.542 -127.836 897.414 -157.297 999.84 -151.201Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.222 -134.679C1112.11 -123.524 1262.87 -128.456 1325.5 -27.9663C1390.38 76.1095 1285.62 207.466 1283.93 330.093C1282.61 425.8 1357.39 522.866 1316.71 609.508C1276.06 696.103 1145.46 692.036 1080.87 762.601C982.288 870.289 992.937 1114.78 847.146 1122.48C704.768 1130 706.037 876.842 594.295 788.288C501.196 714.509 307.216 775.823 268.154 663.64C227.376 546.532 407.71 461.604 438.736 341.543C464.145 243.218 376.206 130.289 428.484 43.2224C480.685 -43.7174 599.61 -57.0836 696.348 -87.5036C794.23 -118.283 892.071 -144.346 994.222 -134.679Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.031 -118.364C1105.46 -103.101 1256.29 -102.769 1315.39 -0.154072C1376.59 106.122 1267.31 233.743 1261.34 356.237C1256.68 451.839 1328.03 551.456 1284.36 636.625C1240.7 721.749 1110.32 713.127 1043.31 781.393C941.031 885.576 943.141 1130.29 797.17 1132.9C654.616 1135.44 664.72 882.484 556.136 790.085C465.668 713.101 269.668 767.608 234.544 654.13C197.878 535.67 381.066 457.087 416.263 338.183C445.089 240.804 361.144 124.875 416.429 39.6858C471.632 -45.3793 590.952 -54.5869 688.692 -81.6123C787.588 -108.957 886.28 -131.589 988.031 -118.364Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29875,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.274 -102.274C1098.1 -82.9222 1248.83 -77.3261 1304.31 27.2882C1361.76 135.636 1248.09 259.365 1237.85 381.576C1229.86 476.957 1297.69 579.004 1251.07 662.597C1204.47 746.145 1074.47 732.978 1005.12 798.864C899.266 899.414 892.835 1144.05 746.862 1141.56C604.306 1139.13 623.231 886.681 517.938 790.548C430.212 710.454 232.429 758.087 201.287 643.453C168.778 523.786 354.596 451.643 393.922 334.04C426.128 237.726 346.281 118.939 404.504 35.7306C462.643 -47.3561 582.211 -52.3939 680.835 -75.9917C780.625 -99.8687 880.047 -119.043 981.274 -102.274Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2575,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M973.96 -86.4299C1090.03 -63.0129 1240.48 -52.1597 1292.27 54.327C1345.91 164.614 1228 284.301 1213.5 406.079C1202.18 501.124 1266.41 605.475 1216.9 687.39C1167.41 769.261 1037.95 751.566 966.337 814.991C857.044 911.786 842.078 1156.05 696.281 1148.47C553.897 1141.06 581.621 889.427 479.747 789.678C394.87 706.572 195.544 747.273 168.422 631.622C140.109 510.893 328.332 445.279 371.738 329.12C407.286 233.989 331.633 112.487 392.725 31.3616C453.728 -49.6454 573.399 -50.5073 672.786 -70.6488C773.349 -91.0286 873.379 -106.721 973.96 -86.4299Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21625,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.097 -70.8507C1081.28 -43.397 1231.26 -27.2999 1279.3 80.9293C1329.06 193.021 1207.04 308.52 1188.3 429.718C1173.67 524.31 1234.22 630.839 1181.88 710.977C1129.57 791.071 1000.81 768.868 927.02 829.755C814.415 922.677 790.934 1166.27 645.49 1153.6C503.451 1141.23 539.94 890.719 441.61 787.476C359.685 701.458 159.06 735.178 135.991 618.651C111.908 497.007 302.306 438.002 349.74 323.429C388.586 229.596 317.22 105.528 381.106 26.5842C444.898 -52.2445 564.527 -48.9294 664.556 -65.5901C765.769 -82.4478 866.286 -94.6398 966.097 -70.8507Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.175,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.696 -55.5554C1071.85 -24.0985 1221.18 -2.77707 1265.41 107.063C1311.23 220.823 1185.25 331.993 1162.29 452.463C1144.37 546.487 1201.17 655.065 1146.06 733.326C1090.99 811.546 963.078 784.863 887.212 843.138C771.432 932.073 739.464 1174.7 594.551 1156.96C453.03 1139.64 498.24 890.556 403.573 783.944C324.699 695.119 123.02 721.817 104.032 604.556C84.2091 482.146 276.55 429.822 327.954 316.973C370.051 224.554 303.058 98.0706 369.66 21.4043C436.165 -55.1501 555.605 -47.662 656.155 -60.8216C757.894 -74.1368 858.776 -82.8134 957.696 -55.5554Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13375,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.766 -40.5626C1061.76 -5.14077 1210.24 21.3789 1250.62 132.696C1292.44 247.985 1162.66 354.691 1135.51 474.287C1114.32 567.628 1167.29 678.122 1109.49 754.412C1051.71 830.662 924.814 799.531 846.96 855.124C728.148 939.964 687.731 1181.33 543.526 1158.54C402.696 1136.3 456.571 888.937 365.682 779.086C289.957 687.563 87.4686 707.206 72.5838 589.354C57.0454 466.327 251.096 420.747 306.406 309.761C351.703 218.867 289.165 90.1232 358.402 15.828C427.538 -58.3588 546.644 -46.7068 647.592 -56.3492C749.734 -66.1057 850.857 -71.2563 948.766 -40.5626Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0925,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.318 -25.8907C1051 13.453 1198.48 45.1387 1234.94 157.797C1272.71 274.475 1139.29 376.587 1107.98 495.163C1083.55 587.707 1132.63 699.982 1072.2 774.209C1011.8 848.396 886.062 812.856 806.315 865.697C684.614 946.339 635.799 1186.15 492.476 1158.34C352.509 1131.19 414.984 885.866 327.983 772.91C255.499 678.8 52.4484 691.364 41.6857 573.064C30.4504 449.569 225.973 410.79 285.123 301.802C333.565 212.544 275.558 81.6959 347.346 9.86224C419.029 -61.8665 537.655 -46.0649 638.879 -52.1785C741.299 -58.3643 842.54 -59.9826 939.318 -25.8907Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.363 -11.5574C1039.61 31.6601 1185.88 68.4732 1218.4 182.335C1252.07 300.261 1115.16 397.654 1079.74 515.065C1052.09 606.7 1097.22 720.62 1034.24 792.692C971.287 864.727 846.868 824.819 765.326 874.846C640.885 951.191 583.73 1189.15 441.465 1156.36C302.53 1124.34 373.529 881.345 290.524 765.421C221.367 668.839 18.0025 674.309 11.3749 555.705C4.45636 431.894 201.213 399.962 264.131 293.105C315.658 205.592 262.253 72.7987 336.504 3.51423C410.647 -65.6691 528.65 -45.7372 630.025 -48.3143C732.599 -50.9219 833.834 -49.006 929.363 -11.5574Z",
    stroke: "#731DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M918.917 2.41981C1027.59 49.4584 1172.49 91.3541 1201.01 206.282C1230.55 325.311 1090.32 417.866 1050.82 533.969C1019.99 624.584 1061.12 740.009 995.659 809.84C930.233 879.633 807.283 835.408 724.045 882.558C597.015 954.514 531.59 1190.33 390.556 1152.6C252.823 1115.75 332.259 875.38 253.35 756.63C187.607 657.693 -15.825 656.062 -18.3094 537.299C-20.9028 413.322 176.849 388.276 243.457 283.68C298.007 198.019 249.269 63.4427 325.893 -3.20826C402.405 -69.7619 519.64 -45.7239 621.043 -44.7615C723.646 -43.7878 824.753 -38.34 918.917 2.41981Z",
    stroke: "#731DFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1750_61426",
    x: -2348.62,
    y: -2741.14,
    width: 5553.08,
    height: 4639.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 693.396,
    result: "effect1_foregroundBlur_1750_61426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1750_61426",
    x: -3163.68,
    y: -912.451,
    width: 7953.51,
    height: 5881.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 381.368,
    result: "effect1_foregroundBlur_1750_61426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1750_61426",
    x: -1396.13,
    y: -3056.41,
    width: 7984.46,
    height: 7984.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1144.1,
    result: "effect1_foregroundBlur_1750_61426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1750_61426",
    x: -3042.95,
    y: -411.104,
    width: 6698.21,
    height: 7301.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1196.11,
    result: "effect1_foregroundBlur_1750_61426"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1750_61426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1860,
    height: 224,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1750_61426"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -339,
    width: 1885,
    height: 2534,
    rx: 200.249,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1750_61426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3003.73,
    height: 2503.11,
    fill: "white",
    transform: "translate(-25 2664.73) rotate(-90)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderBgImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "header-bg-image.657424435e7cc4a47342affd92683cbd.svg";